package navigation.home.request

import navigation.home.request.addeditrequest.AddEditRequestScreenModel
import navigation.home.request.allrequest.AllRequestScreenModel
import org.koin.dsl.module

val requestUiModule
    get() =
        module {
            factory {
                AllRequestScreenModel(
                    requestRepository = get(),
                    areaRepository = get(),
                    proposalRepository = get(),
                    profileRepository = get(),
                    toastManager = get(),
                    loadingManager = get()
                )
            }
            factory {
                AddEditRequestScreenModel(
                    requestRepository = get(),
                    areaRepository = get(),
                    travelAgentRepository = get(),
                    clientRepository = get(),
                    toastManager = get(),
                    loadingManager = get()
                )
            }
        }
